var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 234.287 234.288",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_29_51_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.269,148.48c-11.207,0-84.81,0-96.014,0c-8.082,0-8.082,13,0,13c11.205,0,84.807,0,96.014,0 C169.348,161.48,169.348,148.48,161.269,148.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.269,182.35c-11.207,0-22.409,0-33.616,0c-8.082,0-8.082,13,0,13c11.207,0,22.409,0,33.616,0 C169.348,195.35,169.348,182.35,161.269,182.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.254,104.142c-8.082,0-8.082,13,0,13c11.205,0,84.807,0,96.014,0c8.079,0,8.079-13,0-13 C150.062,104.142,76.464,104.142,65.254,104.142z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.269,125.152c-11.207,0-84.81,0-96.014,0c-8.082,0-8.082,13,0,13c11.205,0,84.807,0,96.014,0 C169.348,138.152,169.348,125.152,161.269,125.152z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.011,62.736c11.208,0,22.412,0,33.619,0c8.079,0,8.079-13,0-13c-11.207,0-22.411,0-33.619,0 C58.938,49.736,58.938,62.736,67.011,62.736z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.011,83.749c11.208,0,22.412,0,33.619,0c8.079,0,8.079-13,0-13c-11.207,0-22.411,0-33.619,0 C58.938,70.749,58.938,83.749,67.011,83.749z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.832,0H26.931v234.288h180.426V32.504L173.832,0z M191.757,218.683H42.53V15.6h123.269v24.75h25.958V218.683z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFile);
export default __webpack_public_path__ + "static/media/text-file.eb9207ef604ead5e51df984a722a1bd5.svg";
export { ForwardRef as ReactComponent };